module.exports = __webpack_public_path__ + "static/media/MuseoSansBold.6a54f672.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBold/MuseoSansBold.woff
// module id = 638
// module chunks = 0